// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3KOYO","box":"WorkspacesBox_box__1HMtG","node":"WorkspacesBox_node__JYOft"};